// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Line4px(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Line4px" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.33569 18.8359L18.8357 2.33594L21.6641 5.16436L5.16412 21.6644L2.33569 18.8359Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Line4px.js.map